<!-- ================================================================
     FSCE 11+ ASSESSMENT PAGE  |  Sehyog Academy
     Classes prefixed fsce-   |  SVG icons inline
================================================================ -->
<div class="fsce-page">

  <!-- SVG SPRITE (hidden) -->
  <svg xmlns="http://www.w3.org/2000/svg" style="display:none;" aria-hidden="true">
    <!-- school/cap -->
    <symbol id="fsce-icon-cap" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5"/>
    </symbol>
    <!-- clipboard/mcq -->
    <symbol id="fsce-icon-mcq" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="8" y="2" width="8" height="4" rx="1"/><rect x="3" y="4" width="18" height="18" rx="2"/>
      <line x1="9" y1="10" x2="15" y2="10"/><line x1="9" y1="14" x2="15" y2="14"/><line x1="9" y1="18" x2="11" y2="18"/>
    </symbol>
    <!-- pencil/write -->
    <symbol id="fsce-icon-write" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </symbol>
    <!-- lightbulb/creative -->
    <symbol id="fsce-icon-bulb" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <line x1="9" y1="18" x2="15" y2="18"/><line x1="10" y1="22" x2="14" y2="22"/>
      <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"/>
    </symbol>
    <!-- telescope/extended -->
    <symbol id="fsce-icon-telescope" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="9" cy="9" r="3"/><path d="M17 21H7l2-7h6l2 7z"/><path d="M21 3 3 9l3 4 15-6z"/>
    </symbol>
    <!-- bar chart / omr -->
    <symbol id="fsce-icon-chart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
    </symbol>
    <!-- scale / age -->
    <symbol id="fsce-icon-scale" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <line x1="12" y1="3" x2="12" y2="21"/><path d="M3 6h18M5 12H3l-1 6h4zm16-6h-2l-1 12h4z"/>
    </symbol>
    <!-- target / focus -->
    <symbol id="fsce-icon-target" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
    </symbol>
    <!-- book open -->
    <symbol id="fsce-icon-book" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
    </symbol>
    <!-- newspaper/read -->
    <symbol id="fsce-icon-news" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/>
      <line x1="16" y1="6" x2="12" y2="6"/><line x1="16" y1="10" x2="12" y2="10"/><line x1="16" y1="14" x2="12" y2="14"/>
    </symbol>
    <!-- file text / paper -->
    <symbol id="fsce-icon-file" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
    </symbol>
    <!-- trending up -->
    <symbol id="fsce-icon-trend" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
    </symbol>
    <!-- shield check -->
    <symbol id="fsce-icon-shield" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>
    </symbol>
    <!-- check circle -->
    <symbol id="fsce-icon-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
    </symbol>
    <!-- volume / audio -->
    <symbol id="fsce-icon-audio" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
    </symbol>
    <!-- users / school -->
    <symbol id="fsce-icon-school" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </symbol>
    <!-- microscope / science -->
    <symbol id="fsce-icon-science" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v8m0 0H3m6 0h12M3 11v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8"/>
    </symbol>
    <!-- globe / geography -->
    <symbol id="fsce-icon-globe" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </symbol>
    <!-- clock / history -->
    <symbol id="fsce-icon-clock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </symbol>
    <!-- monitor / computing -->
    <symbol id="fsce-icon-monitor" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
    </symbol>
    <!-- message / languages -->
    <symbol id="fsce-icon-msg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </symbol>
    <!-- pen tool / art -->
    <symbol id="fsce-icon-pentool" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 19l7-7 3 3-7 7-3-3z"/><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/>
      <path d="M2 2l7.586 7.586"/><circle cx="11" cy="11" r="2"/>
    </symbol>
    <!-- music note -->
    <symbol id="fsce-icon-music" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
    </symbol>
    <!-- activity / pe -->
    <symbol id="fsce-icon-activity" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
    </symbol>
    <!-- tool / dt -->
    <symbol id="fsce-icon-tool" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
    </symbol>
    <!-- award / grad -->
    <symbol id="fsce-icon-award" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
    </symbol>
    <!-- arrow right -->
    <symbol id="fsce-icon-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
    </symbol>
    <!-- info -->
    <symbol id="fsce-icon-info" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </symbol>
    <!-- calendar -->
    <symbol id="fsce-icon-cal" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </symbol>
    <!-- mail -->
    <symbol id="fsce-icon-mail" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
    </symbol>
    <!-- chevron down -->
    <symbol id="fsce-icon-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"/>
    </symbol>
    <!-- alert / warning -->
    <symbol id="fsce-icon-alert" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </symbol>
    <!-- home -->
    <symbol id="fsce-icon-home" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
    </symbol>
    <!-- shuffle / any order -->
    <symbol id="fsce-icon-shuffle" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/>
      <polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/>
      <line x1="4" y1="4" x2="9" y2="9"/>
    </symbol>
  </svg>

  <!-- ══════════════════════════════════════════════════════
       HERO
  ══════════════════════════════════════════════════════ -->
  <section class="fsce-hero">
    <div class="fsce-hero-bg"></div>
    <div class="fsce-orb fsce-orb-a"></div>
    <div class="fsce-orb fsce-orb-b"></div>
    <div class="fsce-orb fsce-orb-c"></div>

    <div class="fsce-container">
      <div class="fsce-hero-inner">

        <!-- Left -->
        <div class="fsce-hero-text">
          <div class="fsce-hero-tag">
            <span class="fsce-htdot"></span>
            New Assessment &middot; Introduced 2022
          </div>
          <h1 class="fsce-hero-h1">
            The FSCE 11+<br/>
            <em>Explained</em> for You
          </h1>
          <p class="fsce-hero-lead">
            Format, subjects tested, partner schools and exactly how to prepare -
            your complete guide to the FSCE 11 Plus from Sehyog Academy.
          </p>
          <div class="fsce-hero-btns">
            <button type="button" class="fsce-btn-primary" (click)="scrollTo('fsce-format')">
              Explore the Format
              <svg class="fsce-btn-ico" aria-hidden="true"><use href="#fsce-icon-arrow"/></svg>
            </button>
            <button type="button" class="fsce-btn-ghost" (click)="scrollTo('fsce-prepare')">
              Preparation Guide
            </button>
          </div>
          <div class="fsce-hero-stats">
            <div class="fsce-hms">
              <div class="fsce-hms-num">2022</div>
              <div class="fsce-hms-lbl">Year Introduced</div>
            </div>
            <div class="fsce-hms-div"></div>
            <div class="fsce-hms">
              <div class="fsce-hms-num">9+</div>
              <div class="fsce-hms-lbl">Partner Schools</div>
            </div>
            <div class="fsce-hms-div"></div>
            <div class="fsce-hms">
              <div class="fsce-hms-num">4</div>
              <div class="fsce-hms-lbl">Papers (Any Order)</div>
            </div>
          </div>
        </div>

        <!-- Right -->
        <div class="fsce-hero-right">
          <div class="fsce-hero-img-wrap">
            <img
              src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=720&q=80&auto=format&fit=crop"
              alt="Students learning"
              class="fsce-hero-img"
              width="720" height="400"
              fetchpriority="high"
              decoding="async"
            />
            <div class="fsce-hero-img-ov"></div>
            <div class="fsce-hero-img-label">
              <div class="fsce-hil-icon">
                <svg class="fsce-hil-svg" aria-hidden="true"><use href="#fsce-icon-cap"/></svg>
              </div>
              <div>
                <div class="fsce-hil-num">9+ Partner Schools</div>
                <div class="fsce-hil-sub">Across the UK using FSCE</div>
              </div>
            </div>
          </div>
          <div class="fsce-hfc fsce-hfc-1">
            <div class="fsce-hfc-icon-wrap">
              <svg class="fsce-hfc-svg" aria-hidden="true"><use href="#fsce-icon-mcq"/></svg>
            </div>
            <div>
              <div class="fsce-hfc-lbl">Assessment Style</div>
              <div class="fsce-hfc-val">Paper-Based</div>
            </div>
          </div>
          <div class="fsce-hfc fsce-hfc-2">
            <div class="fsce-hfc-icon-wrap">
              <svg class="fsce-hfc-svg" aria-hidden="true"><use href="#fsce-icon-cal"/></svg>
            </div>
            <div>
              <div class="fsce-hfc-lbl">Curriculum Base</div>
              <div class="fsce-hfc-val">KS2 Up to Year 5</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Stats bar -->
    <div class="fsce-hero-bar">
      <div class="fsce-hbar-item">
        <div class="fsce-hbar-num">2022</div>
        <div class="fsce-hbar-lbl">Year Introduced</div>
      </div>
      <div class="fsce-hbar-item">
        <div class="fsce-hbar-num">9+</div>
        <div class="fsce-hbar-lbl">Grammar Schools</div>
      </div>
      <div class="fsce-hbar-item">
        <div class="fsce-hbar-num">4</div>
        <div class="fsce-hbar-lbl">Papers (Any Order)</div>
      </div>
    </div>

    <svg class="fsce-wave" viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0 60 L60 52 C120 44 240 28 360 22 C480 16 600 26 720 32 C840 38 960 42 1080 38 C1200 34 1320 18 1380 10 L1440 2 V60 H0Z" fill="#F4F8FA"/>
    </svg>
  </section>

  <!-- ══════════════════════════════════════════════════════
       WHAT IS FSCE
  ══════════════════════════════════════════════════════ -->
  <section class="fsce-what" id="fsce-about">
    <div class="fsce-container">
      <div class="fsce-split">

        <div class="fsce-split-img fsce-rl">
          <img
            src="https://images.unsplash.com/photo-1588072432836-e10032774350?w=700&q=80&auto=format&fit=crop"
            alt="Child learning with teacher"
            width="700" height="440"
            loading="lazy"
            decoding="async"
          />
          <div class="fsce-split-badge">
            <svg class="fsce-sib-svg" aria-hidden="true"><use href="#fsce-icon-shield"/></svg>
            <div class="fsce-sib-lbl">Fair &amp; Accessible</div>
          </div>
        </div>

        <div class="fsce-rr fsce-d1">
          <div class="fsce-pill">
            <svg class="fsce-pill-ico" aria-hidden="true"><use href="#fsce-icon-book"/></svg>
            Overview
          </div>
          <h2 class="fsce-sec-title">What is the FSCE 11 Plus?</h2>
          <p class="fsce-sec-lead">
            Introduced in 2022 by Future Stories Community Enterprise in partnership with Reading School,
            the FSCE 11 Plus creates a more balanced, accessible style of 11+ assessment.
          </p>
          <p class="fsce-sec-lead fsce-mt0">
            The test is extensively trialled and consulted upon with primary school children and teachers.
            Rather than heavily favouring advanced tutoring, it tests how well children can
            <strong>apply knowledge</strong> from primary school - up to the end of Year 5 only.
            Nothing extra or new is introduced beyond what children are already taught.
          </p>
          <ul class="fsce-feat-list">
            <li>
              <div class="fsce-fl-icon"><svg aria-hidden="true"><use href="#fsce-icon-target"/></svg></div>
              Tests application of KS2 knowledge - up to Year 5 only, nothing extra
            </li>
            <li>
              <div class="fsce-fl-icon"><svg aria-hidden="true"><use href="#fsce-icon-audio"/></svg></div>
              Instructions delivered via audio recording - clear and child-friendly
            </li>
            <li>
              <div class="fsce-fl-icon"><svg aria-hidden="true"><use href="#fsce-icon-shuffle"/></svg></div>
              All 4 papers may be sat in any order - question types change year to year
            </li>
            <li>
              <div class="fsce-fl-icon"><svg aria-hidden="true"><use href="#fsce-icon-scale"/></svg></div>
              Age-standardised scoring so all children compete fairly
            </li>
            <li>
              <div class="fsce-fl-icon"><svg aria-hidden="true"><use href="#fsce-icon-school"/></svg></div>
              Used by a growing number of top grammar schools across the UK
            </li>
          </ul>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════
       SCHOOLS
  ══════════════════════════════════════════════════════ -->
  <section class="fsce-schools" id="fsce-schools">
    <div class="fsce-container">
      <div class="fsce-sec-center fsce-reveal">
        <div class="fsce-pill">
          <svg class="fsce-pill-ico" aria-hidden="true"><use href="#fsce-icon-school"/></svg>
          Partner Schools
        </div>
        <h2 class="fsce-sec-title">Which Schools Use the FSCE?</h2>
        <p class="fsce-sec-lead">
          A growing number of grammar schools now use the FSCE for Year 7 admissions,
          including these top institutions:
        </p>
      </div>

      <div class="fsce-schools-grid">
        <div
          class="fsce-school-card fsce-reveal"
          *ngFor="let school of schools; let i = index"
          [class.fsce-d1]="i % 3 === 1"
          [class.fsce-d2]="i % 3 === 2"
        >
          <div class="fsce-sc-icon">
            <svg aria-hidden="true"><use href="#fsce-icon-cap"/></svg>
          </div>
          <span class="fsce-sc-name">{{ school }}</span>
        </div>
      </div>

      <div class="fsce-schools-note fsce-reveal">
        <svg class="fsce-note-ico" aria-hidden="true"><use href="#fsce-icon-info"/></svg>
        Always verify on your chosen school's official website - admissions policies and which papers are used can change year to year.
      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════
       FORMAT
  ══════════════════════════════════════════════════════ -->
  <section class="fsce-format" id="fsce-format">
    <div class="fsce-container">
      <div class="fsce-sec-center fsce-reveal">
        <div class="fsce-pill">
          <svg class="fsce-pill-ico" aria-hidden="true"><use href="#fsce-icon-file"/></svg>
          Test Structure
        </div>
        <h2 class="fsce-sec-title">The FSCE Test Format</h2>
        <p class="fsce-sec-lead">
          There are 4 different papers - which may be sat in any order. Each paper can draw
          on any of the KS2 subjects taught up to Year 5. The type of questions, subjects,
          content and format will change from year to year.
        </p>
      </div>

      <!-- Any-order notice -->
      <div class="fsce-order-notice fsce-reveal">
        <div class="fsce-on-icon">
          <svg aria-hidden="true"><use href="#fsce-icon-shuffle"/></svg>
        </div>
        <div class="fsce-on-txt">
          <strong>Papers may be sat in any order</strong> - your school decides the sequence on the day.
          The subjects, content and question types will also vary from year to year, so broad preparation across all KS2 subjects is essential.
        </div>
      </div>

      <div class="fsce-papers-grid fsce-papers-grid-4">
        <div
          class="fsce-pcard fsce-reveal"
          *ngFor="let p of papers; let i = index"
          [class.fsce-d1]="i === 1"
          [class.fsce-d2]="i === 2"
          [class.fsce-d3]="i === 3"
        >
          <div class="fsce-pcard-bar" [ngClass]="p.barClass"></div>
          <div class="fsce-pcard-body">
            <div class="fsce-pcard-num" [ngClass]="p.numClass">{{ p.num }}</div>
            <div class="fsce-pcard-icon-wrap" [ngClass]="p.numClass + '-bg'">
              <svg class="fsce-pcard-svg" *ngIf="i === 0" aria-hidden="true"><use href="#fsce-icon-mcq"/></svg>
              <svg class="fsce-pcard-svg" *ngIf="i === 1" aria-hidden="true"><use href="#fsce-icon-write"/></svg>
              <svg class="fsce-pcard-svg" *ngIf="i === 2" aria-hidden="true"><use href="#fsce-icon-mcq"/></svg>
              <svg class="fsce-pcard-svg" *ngIf="i === 3" aria-hidden="true"><use href="#fsce-icon-bulb"/></svg>
            </div>
            <div class="fsce-pcard-title">{{ p.title }}</div>
            <p class="fsce-pcard-desc">{{ p.desc }}</p>
            <span class="fsce-pcard-tag" [ngClass]="p.tagClass">{{ p.tagText }}</span>
          </div>
        </div>
      </div>

      <!-- No past papers alert -->
      <div class="fsce-nopaper-box fsce-reveal">
        <div class="fsce-np-icon">
          <svg aria-hidden="true"><use href="#fsce-icon-alert"/></svg>
        </div>
        <div class="fsce-np-txt">
          <h4>No Authorised Past Papers or Practice Papers</h4>
          <p>
            There are <strong>no past papers</strong> and <strong>no practice papers</strong> that have been authorised by FSCE.
            This is why practising under realistic timed conditions - as we provide at Sehyog Academy - is especially valuable for building confidence and familiarity with the format.
          </p>
        </div>
      </div>

    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════
       SUBJECTS
  ══════════════════════════════════════════════════════ -->
  <section class="fsce-subjects" id="fsce-subjects">
    <div class="fsce-container">
      <div class="fsce-subj-layout">

        <!-- Accordions -->
        <div class="fsce-rl">
          <div class="fsce-pill">
            <svg class="fsce-pill-ico" aria-hidden="true"><use href="#fsce-icon-book"/></svg>
            Core Subjects
          </div>
          <h2 class="fsce-sec-title fsce-mb28">What Subjects Are Tested?</h2>
          <p class="fsce-sec-lead">
            Any of the KS2 subjects below may appear across the four papers - covering only
            what children are taught up to the end of Year 5. Nothing extra or beyond the
            school curriculum is introduced.
          </p>

          <div class="fsce-acc-list">

            <!-- English -->
            <div class="fsce-acc-item" [class.fsce-open]="openAccordions['english']">
              <div class="fsce-acc-head" (click)="toggleAccordion('english')">
                <div class="fsce-acc-ic fsce-acc-ic-primary">
                  <svg aria-hidden="true"><use href="#fsce-icon-book"/></svg>
                </div>
                <div class="fsce-acc-htxt">
                  <h3>English</h3>
                  <p>Comprehension, vocabulary &amp; spelling</p>
                </div>
                <div class="fsce-acc-arr" [class.fsce-open-arr]="openAccordions['english']">
                  <svg aria-hidden="true"><use href="#fsce-icon-chev"/></svg>
                </div>
              </div>
              <div class="fsce-acc-body">
                <ul class="fsce-acc-ul">
                  <li>
                    <svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>
                    Reading comprehension - fiction &amp; non-fiction passages
                  </li>
                  <li>
                    <svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>
                    Inference and interpretation skills
                  </li>
                  <li>
                    <svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>
                    Vocabulary - word meanings and synonyms
                  </li>
                  <li>
                    <svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>
                    Spelling through missing-letter exercises in context
                  </li>
                </ul>
              </div>
            </div>

            <!-- Maths -->
            <div class="fsce-acc-item" [class.fsce-open]="openAccordions['maths']">
              <div class="fsce-acc-head" (click)="toggleAccordion('maths')">
                <div class="fsce-acc-ic fsce-acc-ic-secondary">
                  <svg aria-hidden="true"><use href="#fsce-icon-chart"/></svg>
                </div>
                <div class="fsce-acc-htxt">
                  <h3>Maths</h3>
                  <p>KS2 Year 5 curriculum topics</p>
                </div>
                <div class="fsce-acc-arr" [class.fsce-open-arr]="openAccordions['maths']">
                  <svg aria-hidden="true"><use href="#fsce-icon-chev"/></svg>
                </div>
              </div>
              <div class="fsce-acc-body">
                <ul class="fsce-acc-ul">
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Number and place value</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Addition, subtraction, multiplication &amp; division</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Factors, primes, squares and cubes</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Fractions, decimals and percentages</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Measurement, area and volume</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Geometry and angles</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Statistics and graphs</li>
                </ul>
              </div>
            </div>

            <!-- Creative Writing / Discovery -->
            <div class="fsce-acc-item" [class.fsce-open]="openAccordions['writing']">
              <div class="fsce-acc-head" (click)="toggleAccordion('writing')">
                <div class="fsce-acc-ic fsce-acc-ic-gold">
                  <svg aria-hidden="true"><use href="#fsce-icon-bulb"/></svg>
                </div>
                <div class="fsce-acc-htxt">
                  <h3>Creative Response (Discovery Paper)</h3>
                  <p>Imaginative flair &amp; original thinking</p>
                </div>
                <div class="fsce-acc-arr" [class.fsce-open-arr]="openAccordions['writing']">
                  <svg aria-hidden="true"><use href="#fsce-icon-chev"/></svg>
                </div>
              </div>
              <div class="fsce-acc-body">
                <ul class="fsce-acc-ul">
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Tests the ability to think of new and imaginative ideas</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Solving problems in original and unique ways</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Creative and original ideas</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Clear, well-organised structure</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Strong and varied vocabulary</li>
                  <li><svg class="fsce-acc-chk" aria-hidden="true"><use href="#fsce-icon-check"/></svg>Accurate spelling and punctuation</li>
                </ul>
              </div>
            </div>

          </div>
        </div>

        <!-- Image -->
        <div class="fsce-rr fsce-d1">
          <div class="fsce-subj-img">
            <img
              src="https://images.unsplash.com/photo-1509062522246-3755977927d7?w=700&q=80&auto=format&fit=crop"
              alt="Students in classroom"
              width="700" height="520"
              loading="lazy"
              decoding="async"
            />
            <div class="fsce-subj-img-ov"></div>
            <div class="fsce-subj-img-tag">KS2 Up to Year 5 Only</div>
            <div class="fsce-subj-img-txt">
              <h4>Application Over Recall</h4>
              <p>
                All questions focus on topics children are expected to know by the end of Year 5.
                The FSCE is more focused on applying knowledge than simply recalling facts -
                unlike any other 11+ entrance test.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════
       KS2 WIDER SUBJECTS
  ══════════════════════════════════════════════════════ -->
  <section class="fsce-ks2">
    <div class="fsce-container">
      <div class="fsce-sec-center fsce-reveal">
        <div class="fsce-pill">
          <svg class="fsce-pill-ico" aria-hidden="true"><use href="#fsce-icon-globe"/></svg>
          All KS2 Subjects
        </div>
        <h2 class="fsce-sec-title">All Subjects That May Be Tested</h2>
        <p class="fsce-sec-lead">
          The FSCE may include questions from any of the following KS2 subjects -
          all of which children will have been taught up to the end of Year 5.
        </p>
      </div>
      <div class="fsce-ks2-grid">

        <div class="fsce-ks2-chip fsce-reveal">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-pentool"/></svg></div>
          <div class="fsce-ks2-lbl">Art &amp; Design</div>
        </div>
        <div class="fsce-ks2-chip fsce-reveal fsce-d1">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-monitor"/></svg></div>
          <div class="fsce-ks2-lbl">Computing</div>
        </div>
        <div class="fsce-ks2-chip fsce-reveal fsce-d2">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-tool"/></svg></div>
          <div class="fsce-ks2-lbl">Design &amp; Technology</div>
        </div>
        <div class="fsce-ks2-chip fsce-reveal fsce-d3">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-book"/></svg></div>
          <div class="fsce-ks2-lbl">English</div>
        </div>
        <div class="fsce-ks2-chip fsce-reveal">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-globe"/></svg></div>
          <div class="fsce-ks2-lbl">Geography</div>
        </div>
        <div class="fsce-ks2-chip fsce-reveal fsce-d1">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-clock"/></svg></div>
          <div class="fsce-ks2-lbl">History</div>
        </div>
        <div class="fsce-ks2-chip fsce-reveal fsce-d2">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-msg"/></svg></div>
          <div class="fsce-ks2-lbl">Languages</div>
        </div>
        <div class="fsce-ks2-chip fsce-reveal fsce-d3">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-chart"/></svg></div>
          <div class="fsce-ks2-lbl">Maths</div>
        </div>
        <div class="fsce-ks2-chip fsce-reveal">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-music"/></svg></div>
          <div class="fsce-ks2-lbl">Music</div>
        </div>
        <div class="fsce-ks2-chip fsce-reveal fsce-d1">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-activity"/></svg></div>
          <div class="fsce-ks2-lbl">Physical Education</div>
        </div>
        <div class="fsce-ks2-chip fsce-reveal fsce-d2">
          <div class="fsce-ks2-icon"><svg aria-hidden="true"><use href="#fsce-icon-science"/></svg></div>
          <div class="fsce-ks2-lbl">Science</div>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════
       MARKING
  ══════════════════════════════════════════════════════ -->
  <section class="fsce-marking" id="fsce-marking">
    <div class="fsce-container">
      <div class="fsce-mark-layout">

        <div class="fsce-rl">
          <div class="fsce-mark-img-wrap">
            <img
              src="https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=700&q=80&auto=format&fit=crop"
              alt="Student at exam desk"
              width="700" height="430"
              loading="lazy"
              decoding="async"
            />
            <div class="fsce-mark-float">
              <svg class="fsce-mf-svg" aria-hidden="true"><use href="#fsce-icon-scale"/></svg>
              <div class="fsce-mf-val">Age</div>
              <div class="fsce-mf-lbl">Standardised</div>
            </div>
            <div class="fsce-mark-ribbon">
              <div class="fsce-mr-icon"><svg aria-hidden="true"><use href="#fsce-icon-chart"/></svg></div>
              <div>
                <div class="fsce-mr-txt">OMR Electronic Marking</div>
                <div class="fsce-mr-sub">Fast, accurate, consistent results</div>
              </div>
            </div>
          </div>
        </div>

        <div class="fsce-rr fsce-d1">
          <div class="fsce-pill">
            <svg class="fsce-pill-ico" aria-hidden="true"><use href="#fsce-icon-chart"/></svg>
            Scoring System
          </div>
          <h2 class="fsce-sec-title">How is the FSCE Marked?</h2>
          <p class="fsce-sec-lead">
            A fair, age-adjusted system designed to give every child an equal footing -
            regardless of when in the year they were born.
          </p>
          <div class="fsce-mark-cards">
            <div class="fsce-mark-card" *ngFor="let mc of markingCards; let i = index">
              <div class="fsce-mc-ico" [ngClass]="mc.bgClass">
                <svg *ngIf="i === 0" aria-hidden="true"><use href="#fsce-icon-chart"/></svg>
                <svg *ngIf="i === 1" aria-hidden="true"><use href="#fsce-icon-scale"/></svg>
                <svg *ngIf="i === 2" aria-hidden="true"><use href="#fsce-icon-target"/></svg>
              </div>
              <div class="fsce-mc-body">
                <h4>{{ mc.title }}</h4>
                <p>{{ mc.desc }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════
       PREPARATION
  ══════════════════════════════════════════════════════ -->
  <section class="fsce-prep" id="fsce-prepare">
    <div class="fsce-container">
      <div class="fsce-sec-center fsce-reveal">
        <div class="fsce-pill">
          <svg class="fsce-pill-ico" aria-hidden="true"><use href="#fsce-icon-trend"/></svg>
          Preparation Guide
        </div>
        <h2 class="fsce-sec-title">How to Prepare for the FSCE</h2>
        <p class="fsce-sec-lead">
          Because there are no authorised past papers, steady and broad preparation across
          all KS2 subjects builds far more confidence than last-minute cramming.
        </p>
      </div>

      <div class="fsce-prep-grid">
        <div
          class="fsce-prep-card fsce-reveal"
          *ngFor="let step of prepSteps; let i = index"
          [class.fsce-d1]="i === 1"
          [class.fsce-d2]="i === 2"
          [class.fsce-d3]="i === 3"
        >
          <div class="fsce-prep-ghost">{{ step.num }}</div>
          <div class="fsce-prep-icon-wrap">
            <svg *ngIf="i === 0" aria-hidden="true"><use href="#fsce-icon-book"/></svg>
            <svg *ngIf="i === 1" aria-hidden="true"><use href="#fsce-icon-news"/></svg>
            <svg *ngIf="i === 2" aria-hidden="true"><use href="#fsce-icon-target"/></svg>
            <svg *ngIf="i === 3" aria-hidden="true"><use href="#fsce-icon-trend"/></svg>
          </div>
          <h4>{{ step.title }}</h4>
          <p>{{ step.desc }}</p>
        </div>
      </div>

      <div class="fsce-prep-highlight fsce-reveal">
        <div class="fsce-ph-icon">
          <svg aria-hidden="true"><use href="#fsce-icon-award"/></svg>
        </div>
        <div class="fsce-ph-txt">
          <h4>Sehyog Academy FSCE Mock Tests</h4>
          <p>
            Since there are no FSCE-authorised past or practice papers, preparation under realistic
            conditions is especially important. At Sehyog Academy, students prepare through FSCE-style
            mock tests designed to reflect real test conditions - helping children build confidence,
            improve accuracy, and become completely comfortable with the structure and timing of the FSCE 11 Plus.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════
       CTA
  ══════════════════════════════════════════════════════ -->
  <section class="fsce-cta-sec">
    <div class="fsce-container">
      <div class="fsce-cta-box fsce-reveal">

        <div class="fsce-cta-left">
          <h2 class="fsce-cta-title">
            Ready to Start Your<br/>
            <em>FSCE Journey?</em>
          </h2>
          <p class="fsce-cta-lead">
            Expert tutors at Sehyog Academy guide children step by step through all KS2 subjects -
            building the real confidence and broad knowledge they need on exam day.
          </p>
          <div class="fsce-cta-btns">
            <button type="button" class="fsce-btn-primary" [routerLink]="['/11plus-mock-test']">
              Book Assessment
              <svg class="fsce-btn-ico" aria-hidden="true"><use href="#fsce-icon-arrow"/></svg>
            </button>
            <button type="button" class="fsce-btn-ghost" (click)="goToCourses()">
              View Our Courses
            </button>
          </div>
        </div>

        <div class="fsce-cta-right">
          <div class="fsce-csc" *ngFor="let cs of ctaSubjects; let i = index">
            <div class="fsce-csc-ico">
              <svg *ngIf="i === 0" aria-hidden="true"><use href="#fsce-icon-book"/></svg>
              <svg *ngIf="i === 1" aria-hidden="true"><use href="#fsce-icon-chart"/></svg>
              <svg *ngIf="i === 2" aria-hidden="true"><use href="#fsce-icon-bulb"/></svg>
              <svg *ngIf="i === 3" aria-hidden="true"><use href="#fsce-icon-file"/></svg>
            </div>
            <div>
              <div class="fsce-csc-title">{{ cs.title }}</div>
              <div class="fsce-csc-sub">{{ cs.sub }}</div>
            </div>
            <div class="fsce-csc-arr">
              <svg aria-hidden="true"><use href="#fsce-icon-arrow"/></svg>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

</div>
